"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "romano-d-ezzelino": {
    "c49b6afe": [{
      "hkey": "694cc92e",
      "slug": "san-giacomo-fellette",
      "name": "San Giacomo-Fellette",
      "primary": true,
      "skipSearch": false
    }],
    "fellette": [{
      "hkey": "694cc92e",
      "slug": "san-giacomo-fellette",
      "name": "San Giacomo-Fellette",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "romano-d-ezzelino"
    }],
    "6584aaa4": [{
      "hkey": "694cc92e",
      "slug": "san-giacomo-fellette",
      "name": "San Giacomo-Fellette",
      "primary": true,
      "skipSearch": false
    }],
    "san-giacomo": [{
      "hkey": "694cc92e",
      "slug": "san-giacomo-fellette",
      "name": "San Giacomo-Fellette",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0555e317": [{
      "hkey": "694cc92e",
      "slug": "san-giacomo-fellette",
      "name": "San Giacomo-Fellette",
      "primary": true,
      "skipSearch": false
    }],
    "spin": [{
      "hkey": "694cc92e",
      "slug": "san-giacomo-fellette",
      "name": "San Giacomo-Fellette",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "romano-d-ezzelino"
    }]
  }
};
exports["default"] = _default;